import { CommonModule, CurrencyPipe } from '@angular/common';
import { HttpClient, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, Injector, NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpLoaderFactory } from '../app/shared.module';
import {environment} from '../environments/environment';

import { SaleItemSelectorComponent } from './sale-item-selector.component';

// SE FE Components
import { SeFeButtonModule } from 'se-fe-button';
import { SeFeEmptyStateModule } from 'se-fe-empty-state';
import { SeFeGridModule } from 'se-fe-grid';
import { SeFeModalModule } from 'se-fe-modal';
import { SeFePaginationModule } from 'se-fe-pagination';
import { SeFeServiceModule } from 'se-fe-service';
import { SeFeSpinnerModule } from 'se-fe-spinner';
import { SeFeTableModule } from 'se-fe-table';
import { SeFeToolbarModule } from 'se-fe-toolbar';
import { SeFePopoverModule } from 'se-fe-popover';

@NgModule({ declarations: [
        SaleItemSelectorComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA], imports: [BrowserModule,
        CommonModule,
        ReactiveFormsModule,
        SeFeButtonModule,
        SeFeEmptyStateModule,
        SeFeGridModule,
        SeFeModalModule,
        SeFePaginationModule,
        SeFeServiceModule.forRoot({ domainEnvironments: environment.domainEnvironments }),
        SeFeTableModule,
        SeFeToolbarModule,
        SeFeSpinnerModule,
        SeFeGridModule,
        SeFePopoverModule,
        TranslateModule.forRoot({
            defaultLanguage: 'en',
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        })], providers: [
        CurrencyPipe,
        provideHttpClient(withXhr(), withInterceptorsFromDi())
    ] })
export class SaleItemSelectorModule {
  constructor(private injector: Injector) {}

  public ngDoBootstrap() {
    const el = createCustomElement(SaleItemSelectorComponent, { injector: this.injector });
    if (!customElements.get('sale-item-selector-element')) {
      customElements.define('sale-item-selector-element', el);
    }
  }
}
